import { lazy, Suspense, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PathBuilderComingSoonDialog from '../Components/Dialogs/PathBuilder/PathBuilderComingSoonDialog';
import { features } from '../config/features';

const PathBuilderPage = lazy(() => import('./PathBuilderPage'));

export function PathBuilderRoute() {
  const navigate = useNavigate();
  const { id: projectId } = useParams();

  const handleCloseComingSoon = useCallback(() => {
    if (projectId) {
      navigate(`/editor/${projectId}`, { replace: true });
      return;
    }
    navigate('/', { replace: true });
  }, [navigate, projectId]);

  if (!features.pathBuilder) {
    return <PathBuilderComingSoonDialog open onClose={handleCloseComingSoon} />;
  }

  return (
    <Suspense fallback={null}>
      <PathBuilderPage />
    </Suspense>
  );
}
